import { useQuery } from "@tanstack/react-query";

import {
  getBloodGlucoseData,
  getDateRange,
  getGroupByInterval
  
} from "~/api/bloodGlucose";
import type {BloodGlucoseParams} from "~/api/bloodGlucose";

type TimeRange = "1d" | "7d" | "1m" | "6m" | "1y";

interface UseBloodGlucoseDataParams {
  patientId: number;
  timeRange: TimeRange;
  navigationOffset?: number;
  selectedDate?: Date;
}

export const useBloodGlucoseData = ({
  patientId,
  timeRange,
  navigationOffset = 0,
  selectedDate,
}: UseBloodGlucoseDataParams) => {
  const dateRange = getDateRange(timeRange, navigationOffset, selectedDate);

  const params: BloodGlucoseParams = {
    patient_id: patientId,
    start_date: dateRange.start_date,
    stop_date: dateRange.stop_date,
    group_by_interval: getGroupByInterval(timeRange),
  };

  return useQuery({
    queryKey: [
      "bloodGlucose",
      patientId,
      timeRange,
      navigationOffset,
      selectedDate,
      params,
    ],
    queryFn: () => getBloodGlucoseData(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!patientId,
  });
};
